export const environment = {
  production: false,
  apigee: {
    host: "https://api.qa.aritzia.com",
    banner: "Aritzia_CA",
    inboundPath: "/concierge/events/inbound",
    deletionPath:"/pubsub/publish/message/atz-retail-concierge-qa/delete-employee-events",
    outboundPath: "/concierge/events/outbound",
    tokenPath: "/oauth2/token"
  },
  azure: {
    redirectUri: "https://cti.qa.aritzia.com",
    graphApi: "https://graph.microsoft.com/v1.0/me?$select=employeeId"
  },
  ctiTargetOrigin: "https://my346364-sso.crm.ondemand.com",
  DataDogEnv: 'qa'
}
